var _path, _path2, _circle, _path3, _circle2, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconShieldPeople = function SvgIconShieldPeople(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 69,
    viewBox: "0 0 100 69",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.6741 65.427C55.6786 63.305 36.2118 50.001 39.7073 11.5872C45.8638 11.6709 57.5312 9.95021 65.7917 2.19464C70.6182 6.52426 78.2955 12.2904 91.4456 11.6231C92.466 19.5028 92.3351 31.0829 88.7923 41.6284C85.2302 52.2315 78.2823 61.6488 65.6741 65.427Z",
    fill: "#00BFFF",
    stroke: "#006FBA",
    strokeWidth: 3.18182
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3621 33.8631L64.5992 36.806C65.0301 37.1977 65.6896 37.1929 66.1148 36.795L73.8621 29.5449",
    stroke: "#006FBA",
    strokeWidth: 3.18182,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.9107,
    cy: 35.2271,
    r: 15.4545,
    fill: "#B0E8FB",
    stroke: "#006FBA",
    strokeWidth: 3.18182
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.628 56.4674C56.45 59.2039 58.1785 62.7884 58.5573 66.5909L24.3973 66.5909C24.7761 62.7884 26.5046 59.2039 29.3265 56.4674C32.541 53.3504 36.9109 51.5909 41.4773 51.5909C46.0437 51.5909 50.4136 53.3504 53.628 56.4674Z",
    fill: "#B0E8FB",
    stroke: "#006FBA",
    strokeWidth: 3.18182
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5016,
    cy: 45.4554,
    r: 9.77273,
    fill: "#B0E8FB",
    stroke: "#006FBA",
    strokeWidth: 3.18182
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1661 59.6139C21.8877 61.492 22.9944 63.9477 23.3135 66.5904L1.68649 66.5904C2.00559 63.9477 3.11232 61.492 4.83391 59.6139C6.89259 57.3681 9.65361 56.1358 12.5 56.1358C15.3464 56.1358 18.1074 57.3681 20.1661 59.6139Z",
    fill: "#B0E8FB",
    stroke: "#006FBA",
    strokeWidth: 3.18182
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8645 45.4554C93.8645 50.7805 89.3088 55.2282 83.5236 55.2282C77.7385 55.2282 73.1827 50.7805 73.1827 45.4554C73.1827 40.1304 77.7385 35.6827 83.5236 35.6827C89.3088 35.6827 93.8645 40.1304 93.8645 45.4554Z",
    fill: "#B0E8FB",
    stroke: "#006FBA",
    strokeWidth: 3.18182
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7579 59.6139C93.4795 61.492 94.5862 63.9477 94.9053 66.5904L73.2783 66.5904C73.5974 63.9477 74.7041 61.492 76.4257 59.6139C78.4844 57.3681 81.2454 56.1358 84.0918 56.1358C86.9382 56.1358 89.6992 57.3681 91.7579 59.6139Z",
    fill: "#B0E8FB",
    stroke: "#006FBA",
    strokeWidth: 3.18182
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconShieldPeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-shield-people.6829b214.svg";
export { ForwardRef as ReactComponent };